export enum MapType {
    AUTO = 2,
    MANUAL = 1
}